import { optionsToVariantName } from "@helpers/products/optionsToVariantName";

import { Item } from "@typings/product/item";
import { Offer } from "@typings/product/offer";

export const getProductPrice = (
  item: Item,
  offer: Offer,
  selectedOptions: { [optionId: number]: number },
  isPromotion = false,
  variantName?: string
) => {
  if (item.category.name === "Free Gift") {
    // For free gifts, find the variant by name and offer
    if (variantName) {
      const variant = item.variants.find((v) => v.name === variantName && v.offerId === offer.id);

      if (variant) {
        return { price: variant.price, oldPrice: variant.price };
      }
    }

    return { price: 0, oldPrice: 0 };
  }

  const targetVariantName = variantName || optionsToVariantName(item.options, selectedOptions);

  let { price } = item.variants.find(
    (v) => v.offerId === offer.id && v.name === targetVariantName
  )!;
  let oldPrice = price;

  if (isPromotion) {
    price = +(price * 0.75).toFixed(2);
  }

  // To show difference in price between subscription and one time offers
  // Not eligible for promotions
  if (!isPromotion && offer.name === "Monthly Subscription") {
    oldPrice = item.variants.find(
      (v) => v.offerId !== offer.id && v.name === targetVariantName
    )!.price;
  }

  return { price, oldPrice };
};
